import { useNavigate, Link } from 'react-router-dom'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { AuthLayout } from '@/layout/AuthLayout'
import { SignInForm } from '@/components/SignInForm'

export function SignIn() {
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/')
  }

  return (
    <AuthLayout>
      <Card className="border-0 shadow-none">
        <CardHeader className="pb-4">
          <CardTitle className="text-2xl py-4">Sign In</CardTitle>
          <CardDescription className="text-xs text-slate-600 dark:text-slate-400">
            New User?{' '}
            <Link
              to="/auth/signup"
              className="text-blue-700 hover:underline dark:text-blue-400"
            >
              Create an account
            </Link>
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <SignInForm onSuccess={handleSuccess} showLinks={true} />
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
